import { GameplayTier } from '#src/__generated__/globalTypes.ts';
import {
  StarIcons,
  Stars,
} from '#src/components/card/StarRank/Stars/index.tsx';
import { useGameplayTierRatings } from '#src/hooks/useGameplayTierRatings.ts';
import {
  GAMEPLAY_TIER_LABELS,
  gameplayTierStarCount,
} from '#src/lib/gameplayTiers.ts';
import type { Unit } from '#src/lib/style.ts';

export type GameplayTierStarsVariant = 'default' | 'flat';

type GameplayTierStarsProps = {
  gameplayTier: GameplayTier;
  size?: Unit;
  variant?: GameplayTierStarsVariant;
};

export const GameplayTierStars = ({
  gameplayTier,
  size = 1,
  variant = 'default',
}: GameplayTierStarsProps) => {
  const { starsOf } = useGameplayTierRatings();
  const nbStars = starsOf(gameplayTier) ?? gameplayTierStarCount(gameplayTier);
  const accessibilityLabel = GAMEPLAY_TIER_LABELS[gameplayTier];

  if (variant === 'flat') {
    return (
      <span className="inline-flex items-center justify-center">
        <StarIcons count={nbStars} size={size} />
        <span className="sr-only">{accessibilityLabel}</span>
      </span>
    );
  }

  return (
    <Stars
      count={nbStars}
      size={size}
      sparkles={GameplayTier.GOAT === gameplayTier}
    >
      <span className="sr-only">{accessibilityLabel}</span>
    </Stars>
  );
};
